import 'es6-promise/auto';
import Vue from 'vue';
import Vuex, {Payload, Store} from 'vuex';
import VuexPersistence from 'vuex-persist';
import mutations from './mutations';
import actions from './actions';
import { initialStateGlobalSettings } from './state';
import { amountTermsFa } from '../api/graphql/queries/setup/AllAmountTermsFA';
import { amountTermsWc } from '../api/graphql/queries/setup/AllAmountTermsWC';
Vue.use(Vuex);

// ============Vuex Persistence object start===========
const vuexLocal = new VuexPersistence({
    key: 'sef',
    storage: window.localStorage,
    reducer: state => ({
        backup: state.backup,
        user: state.user,
        idleTime: state.idleTime,
        daysResume: state.daysResume,
        alert: state.alert,
        salary: state.salary,
        ipc: state.ipc,
        health: state.health,
        pension: state.pension,
        arl: state.arl,
        compensation: state.compensation,
        severancePayInterest: state.severancePayInterest,
        ageForAssurance: state.ageForAssurance,
        ageForAssurancePercentBelow: state.ageForAssurancePercentBelow,
        ageForAssurancePercentAbove: state.ageForAssurancePercentAbove,
        assesments: state.assesments,
        actualAssesment: state.actualAssesment,
        methodologicalPillars: state.methodologicalPillars,
        activityTypes: state.activityTypes,
        accountTypes: state.accountTypes,
        clientTypes: state.clientTypes,
        financialObligationTypes: state.financialObligationTypes,
        contingentQuotasTdcPyme: state.contingentQuotasTdcPyme,
        contingentQuotasTdcAgro: state.contingentQuotasTdcAgro,
        productTypes: state.productTypes,
        creditTypes: state.creditTypes,
        creditPurposes: state.creditPurposes,
        identificationDocumentTypes: state.identificationDocumentTypes,
        catalogSalePercent: state.catalogSalePercent,
        economicActivities: state.economicActivities,
        professions: state.professions,
        amountTermsFa: state.amountTermsFa,
        amountTermsWc: state.amountTermsWc,
        commissions: state.commissions,
        creditRates: state.creditRates,
        isCustomer: state.isCustomer,
        isSpouse: state.isSpouse,
        isGuarantor: state.isGuarantor,
        emptyAssesment: state.emptyAssesment,
        beforePathMenu: state.beforePathMenu,
        assesmentEditing: state.assesmentEditing,
        connectivityState: state.connectivityState,
        productionSalesLocked: state.productionSalesLocked,
        productionCostsLocked: state.productionCostsLocked,
        syncAssessment: state.syncAssessment,
        reloadPage: state.reloadPage,
        syncReturn: state.syncReturn
    })
})
// ============Vuex Persistence object end===========

//=======vuex store start===========
const store = new Vuex.Store({
    state: {
        syncReturn: false,
        backup: false,
        assesmentEditing: false,
        productionSalesLocked: false,
        productionCostsLocked: false,
        connectivityState: true,
        logoutState: false,
        idleLogout: false,
        idleTime: 360000,
        daysResume: 0,
        alert: null,
        salary: null,
        ipc: null,
        resetToken: null,
        resetUserId: null,
        user: {},
        methodologicalPillars: [],
        assesments: [],
        activityTypes: [],
        accountTypes: [],
        clientTypes: [],
        financialObligationTypes: [],
        contingentQuotasTdcPyme: [],
        contingentQuotasTdcAgro: [],
        productTypes: [],
        creditTypes: [],
        creditPurposes: [],
        economicActivities: [],
        professions: [],
        amountTermsFa: [],
        amountTermsWc: [],
        commissions: [],
        creditRates: [],
        identificationDocumentTypes: [],
        catalogSalePercent: [],
        isCustomer: false,
        isSpouse: false,
        isGuarantor: false,
        actualAssesment: null,
        activityTypeSubcategory: null,
        emptyAsessment: true,
        syncAssessment: null,
        beforePathMenu: null,
        reloadPage: false,
        packageVersion: process.env.PACKAGE_VERSION || '0',
        
    },
    mutations ,
    actions,
    plugins: [vuexLocal.plugin],
    getters: {
        getSubcategory: state => {
            return state.activityTypeSubcategory;
        },
        getUserFullName: state => {
            return state.user.fullName;
        },
        getUserEmail: state => {
            return state.user.email;
        },
        getIdleTime: state => {
            return state.idleTime;
        },
        isLoggedIn: state => {
            return state.loggingIn;
        },
        idIdleLogout: state => {
            return state.idleLogout;
        },
        getResetToken: state => {
            return state.resetToken;
        },
        getResetUserId: state => {
            return state.resetUserId;
        },
        getLogoutState: state => {
            return state.logoutState;
        },
        getActivityTypes: state => {
            return state.activityTypes;
        },
        getAccountTypes: state => {
            return state.accountTypes;
        },
        getClientTypes: state => {
            return state.clientTypes;
        },
        getFinancialObligationTypes: state => {
            return state.financialObligationTypes;
        },
        getContingentQuotasTdcPyme: state => {
            return state.contingentQuotasTdcPyme;
        },
        getContingentQuotasTdcAgro: state => {
            return state.contingentQuotasTdcAgro;
        },
        getProductTypes: state => {
            return state.productTypes;
        },
        getCreditTypes: state => {
            return state.creditTypes;
        },
        getCreditPurposes: state => {
            return state.creditPurposes;
        },
        getIdentificationDocumentTypes: state => {
            return state.identificationDocumentTypes;
        },
        getMethodologicalPillars: state => {
            return state.methodologicalPillars;
        },
        getCatalogSalePercent: state => {
            return state.catalogSalePercent;
        },
        getEconomicActivities: state => {
            return state.economicActivities;
        },
        getProfessions: state => {
            return state.professions;
        },
        getAmountTermsFa: state => {
            return state.amountTermsFa;
        },
        getAmountTermsWc: state => {
            return state.amountTermsWc;
        },
        getCommissions: state => {
            return state.commissions;
        },
        getCreditRates: state => {
            return state.creditRates;
        },
        getReloadPage: state => {
            return state.reloadPage;
        },
        appVersion: (state) => {
            return state.packageVersion
        }
    }
});
//=======vuex store end===========
export default store
